module.exports = __webpack_public_path__ + "static/img/after-sale-lynx-1.beaf06b4.png";